import { ProgressTheme } from "@gravity-ui/uikit";

export const status = {
  active: "В работе",
  waiting: "В ожидание",
  completed: "Успешно",
  delayed: "Повторяющаяся",
  failed: "Ошибка",
  unknown: "Неизвестно",
  stopped: "Прервана",
};

export const progressTheme: Record<string, ProgressTheme> = {
  active: "warning",
  waiting: "info",
  completed: "success",
  delayed: "info",
  failed: "danger",
  unknown: "default",
  stopped: "misc",
};
